// Configuration utility for API settings
export const checkApiConfig = () => {
  const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    bearerToken: process.env.REACT_APP_BEARER_TOKEN,
    isConfigured: false,
    issues: [],
  };

  if (!config.apiBaseUrl) {
    config.issues.push("REACT_APP_API_BASE_URL is not defined");
  }

  if (!config.bearerToken) {
    config.issues.push("REACT_APP_BEARER_TOKEN is not defined");
  }

  if (config.apiBaseUrl && config.bearerToken) {
    config.isConfigured = true;
  }

  return config;
};

export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";
};

export const getBearerToken = () => {
  return process.env.REACT_APP_BEARER_TOKEN;
};

export const logApiConfig = () => {
  const config = checkApiConfig();
  console.log("API Configuration Status:", config);

  if (!config.isConfigured) {
    console.warn("⚠️ API configuration issues detected:");
    config.issues.forEach((issue) => console.warn(`  - ${issue}`));
    console.warn("Please check your .env file or environment variables.");
  }

  return config;
};

export const loadFile = (url) => {
  if (
    url.startsWith("/") ||
    url.startsWith("blob:") ||
    url.startsWith("data:")
  ) {
    return url;
  }
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_STORAGE_URL}/${url}`;
};

export const formatUrl = (src) => {
  if (!src) return src;

  const url = loadFile(src);
  if (
    url.toString().startsWith("blob:") ||
    url.toString().startsWith("data:") ||
    url.toString().startsWith("/")
  ) {
    return url;
  }
  try {
    // Only encode the path part, not the domain
    const urlObj = new URL(url);
    urlObj.pathname = urlObj.pathname
      .split("/")
      .map((segment) => encodeURIComponent(decodeURIComponent(segment)))
      .join("/");
    return urlObj.toString();
  } catch {
    return encodeURI(url);
  }
};
